// require('./bootstrap');
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'intersection-observer' // Optional

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueMq from 'vue-mq'
import languageLevel from './components/career/LanguageLevel.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import axios from 'axios'
import { updateGuidelineRoot } from './helper.js'

// Set the components prop default to return our fresh components 
vSelect.props.components.default = () => ({
    Deselect: {
        render: createElement => createElement('span', '❌'),
    },
    OpenIndicator: {
        render: createElement => createElement('span', '🔽'),
    },
});

// Register the component
Vue.component(vSelect)

// import VueInputMask from 'vue-inputmask'
const VueInputMask = require('vue-inputmask').default

Vue.use(VueInputMask)
Vue.use(BootstrapVue)
Vue.use(VueMq, {
    breakpoints: {
        sm: 576,
        md: 768,
        lg: Infinity
    }
})

const app = new Vue({
    el: '#career-search',
    created() {
        this.getCareer();
        this.getProvince();
        this.getJobFunction();
        this.getJobPosition();
    },
    mounted() {
    },
    data() {
        return {
            jobs: [],
            functions: [],
            types: [],
            provinces: [],
            positions: [],
            selected_function: '',
            selected_province: '',
            selected_position: '',
            selected_type: '',
            search_word: '',
            iconjob: [],
            searching: false,
            page: 1,
            perPage: 6,
            pages: [],
            loading: false,
            search_result : '',
            start_sort: '',
        }
    },
    methods: {
        enter(e) {
            if(e.keyCode === 13) {
                // e.preventDefault()
                this.search(e);
            }
        },
        search(e) {
            e.preventDefault()
            this.search_check=true;
            this.searching = true;

            if(this.selected_position == '' && this.selected_province == '' && this.selected_type == '' && this.search_word == ''){
                this.searching = false;
            }
            
            let url = '/api/career/getCareer/available'
            let selected_position, selected_province, selected_type

            if (this.selected_position != '' && this.selected_position != null) {
                selected_position = this.selected_position
            } else {                
                selected_position = 'none'
            }

            if (this.selected_province != '' && this.selected_province != null) {
                selected_province = this.selected_province
            } else {
                selected_province = 'none'
            }

            if (this.selected_type != '' && this.selected_type != null) {
                selected_type = this.selected_type
            } else {
                selected_type = 'none'
            }

            url = url + '/' + selected_position + '/' + selected_province + '/' + selected_type

            if (this.search_word !== '') {
                url = url + '/' + this.search_word
            }

            this.loading = true;

            axios
                .get(url)
                .then(response => {
                    this.loading = false
                    this.jobs = response.data.career;
                    this.search_result = this.searchResult();
                    updateGuidelineRoot();
                })
                .catch(error => {
                    console.log(error)
                })
            
        },
        searchResult() {
            let search_arr = this.search_word ? ['"'+this.search_word+'"'] : [];

            let selected_position_obj = this.positions.find(obj => {
                return obj.value === this.selected_position && obj.value != ""
            });
            if(selected_position_obj) {
                search_arr.push(selected_position_obj.text)
            }else{
                this.selected_position = [];
            }

            let selected_province_obj = this.provinces.find(obj => {
                return obj.value === this.selected_province && obj.value != ""
            });
            if(selected_province_obj) {
                search_arr.push(selected_province_obj.text)
            }else{
                this.selected_province = [];
            }

            let selected_type_obj = this.types.find(obj => {
                return obj.value === this.selected_type && obj.value != ""
            })
            if(selected_type_obj) {
                search_arr.push(selected_type_obj.text)
            }else{
                this.selected_type = [];
            }
            
            return search_arr.join(" / ");
        },
        getProvince() {
            axios
                .get('/api/career/getProvince')
                .then(response => {
                    let job_provinces = [];
                    job_provinces.push({value:"",text:'ค้นหาจากพื้นที่'});
                    response.data.province.forEach(function (province, i) {
                        let option = {
                            value: province.id,
                            text: province.province,
                        }
                        job_provinces.push(option)
                    })
                    this.provinces = job_provinces;
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getJobFunction() {
            axios
                .get('/api/career/getJobFunction')
                .then(response => {
                    let job_functions = [];
                    response.data.job_function.forEach(function (job_f, i) {
                        let option = {
                            value: job_f.id,
                            text: job_f.name,
                        }
                        job_functions.push(option)
                    })
                    this.functions = job_functions;
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getJobFunction() {
            axios
                .get('/api/career/getJobType')
                .then(response => {
                    let job_types = [];
                    job_types.push({value:"",text:'ค้นหาจากประเภทงาน'});
                    response.data.job_types.forEach(function (job_t, i) {
                        let option = {
                            value: job_t.id,
                            text: job_t.name,
                        }
                        job_types.push(option)
                    })
                    this.types = job_types;
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getJobPosition() {
            axios
                .get('/api/career/getJobPosition')
                .then(response => {
                    let job_positions = [];
                    job_positions.push({value:"",text:'ค้นหาตำแหน่งงาน'});
                    response.data.job_types.forEach(function (pos, i) {
                        let option = {
                            value: pos.id,
                            text: pos.name,
                        }
                        job_positions.push(option)
                    })
                    this.positions = job_positions;
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getCareer() {
            axios
                .get('/api/career/getCareer/available')
                .then(response => {
                    this.jobs = response.data.career;
                })
                .catch(error => {
                    console.log(error)
                })
        },
        setPages() {
            let numberOfPages = Math.ceil(this.jobs.length / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },
        paginate(jobs) {
            let page = this.page;
            let perPage = this.perPage;
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
        
            return jobs.slice(from, to);
        },
        clickAndScroll(){
            if(this.start_sort==''){
                this.start_sort="ok";
            }
        }, 
    },
    components: {
        languagelevel: languageLevel,
        vselect: vSelect
    },
    watch: {
        jobs() {
            this.page = 1;
            this.pages = [];
            this.setPages();
        }
    },
    computed: {
        displayedJobs() {
            if(this.start_sort!=''){                
                setTimeout(function() {
                    document.querySelector('#anchor-search').scrollIntoView();
                }, 20);
            }
            return this.paginate(this.jobs);
        }
    },
});



// WEBPACK FOOTER //
// ./resources/js/career-search.js